// extracted by mini-css-extract-plugin
export var bodyRow = "_ga-d";
export var cardColumns = "_ga-e";
export var ellipsesOverflow = "_ga-2";
export var flatBottomCorners = "_ga-3";
export var flatTopCorners = "_ga-4";
export var headerActionsDropdown = "_ga-f";
export var headerBottomRow = "_ga-c";
export var headerTopRow = "_ga-b";
export var orderDetailsWrapper = "_ga-0";
export var orderInfoContainer = "_ga-1";
export var productDetails = "_ga-9";
export var productImage = "_ga-5";
export var responsiveTable = "_ga-8";
export var shipmentContainer = "_ga-a";
export var tableBottomLeft = "_ga-6";
export var tableBottomRight = "_ga-7";
export var trackingLink = "_ga-g";